import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "folder-structure"
    }}>{`Folder Structure`}</h1>
    <p>{`The folder structure of Headless GraphQL is following like that.`}</p>
    <p><img alt="ProjectStructure.png" src={require("./images/ProjectStructure.png")} /></p>
    <p><strong parentName="p">{`node_modules:`}</strong>{` It contains all the npm packages that is used on this projects.`}</p>
    <p><strong parentName="p">{`packages:`}</strong>{` It's came from mono repo concepts. It's contain all kind of module which gave
the share able module structure.`}</p>
    <p><img alt="Packages.png" src={require("./images/Packages.png")} /></p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`core:`}</strong>{` Contain Project Specific components.`}</li>
      <li parentName="ul"><strong parentName="li">{`importer:`}</strong>{` Contain demo data import functions.`}</li>
      <li parentName="ul"><strong parentName="li">{`reusecore:`}</strong>{` Contain Reusable Components.`}</li>
      <li parentName="ul"><strong parentName="li">{`server:`}</strong>{` Contain Server Related File and Funtions.`}</li>
      <li parentName="ul"><strong parentName="li">{`web:`}</strong>{` It's the core of the project front-end.`}</li>
    </ul>
    <p><img alt="WebStructure.png" src={require("./images/WebStructure.png")} /></p>
    <p><strong parentName="p">{`web module:`}</strong></p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`components:`}</strong>{` contain the compose components for this project.`}</li>
      <li parentName="ul"><strong parentName="li">{`containers:`}</strong>{` Collections of page specific components.`}</li>
      <li parentName="ul"><strong parentName="li">{`context:`}</strong>{` components which is build using react context API.`}</li>
      <li parentName="ul"><strong parentName="li">{`helpers:`}</strong>{` contains all kind of helper functions like: init-apollo, urlHelpers etc .`}</li>
      <li parentName="ul"><strong parentName="li">{`hoc:`}</strong>{` Contain's component which is build using react Higher Order Components pattern Like: AppLayout etc.`}</li>
      <li parentName="ul"><strong parentName="li">{`pages:`}</strong>{` In next.js the file-system is the main API. Every .js file becomes a route that gets automatically processed and rendered. so all the route file is here.`}</li>
      <li parentName="ul"><strong parentName="li">{`next.config.js:`}</strong>{` contain extended next configurations like css module support, font import, image import and optimization and env variables.`}</li>
      <li parentName="ul"><strong parentName="li">{`package.json:`}</strong>{` Contains all the informations about the specific module packages, scripts etc .`}</li>
    </ul>
    <p><strong parentName="p">{`public:`}</strong>{` Contains public files used on the projects like icon files.`}</p>
    <p><strong parentName="p">{`package.json:`}</strong>{` Contains all the informations about the workspace like third party packages, scripts etc .`}</p>
    <p><strong parentName="p">{`lerna.json:`}</strong>{` Contains lerna and yarn workspace config.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      